// Settings → Mods: turn mods on and off, add your own (paste or a .js file), and show hidden mod windows.
import type { ModHost } from '../mods/host.js';

function el<K extends keyof HTMLElementTagNameMap>(tag: K, cls = '', text = ''): HTMLElementTagNameMap[K] { const e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }

export function modsTab(mods: ModHost, rerender: () => void) {
  mods.onChange = () => { if (document.querySelector('#settingsTabs [aria-selected="true"]')?.textContent === 'Mods') rerender(); };
  return {
    id: 'mods', label: 'Mods',
    render(box: HTMLElement): void {
      if (mods.safe) box.append(el('p', 'note', 'Safe mode (?safe=1): every mod is off for this visit.'));
      box.append(el('p', 'set-note', 'Mods add windows and colors to the interface. They run sealed off from the game: they can read what happens on your screen, but can\'t reach the internet, see your sign-in, or act for you.'));
      for (const m of mods.mods) {
        const row = el('div', 'mod-row'), top = el('div', 'mod-top');
        const tog = el('input'); tog.type = 'checkbox'; tog.checked = m.enabled; tog.disabled = mods.safe; tog.setAttribute('aria-label', 'Turn ' + m.name + ' on');
        tog.addEventListener('change', () => mods.setEnabled(m.id, tog.checked));
        const name = el('b', '', m.name), ver = el('small', '', `v${m.version} · ${m.author}${m.builtin ? ' · built in' : ''}`);
        top.append(tog, name, ver);
        if (mods.isRunning(m.id)) { const s = el('button', 'pf-mini', 'Show'); s.type = 'button'; s.addEventListener('click', () => mods.show(m.id)); top.append(s); }
        if (!m.builtin) { const r = el('button', 'pf-mini', 'Remove'); r.type = 'button'; r.addEventListener('click', () => mods.remove(m.id)); top.append(r); }
        row.append(top);
        if (m.description) row.append(el('div', 'mod-desc', m.description));
        const err = mods.errorOf(m.id); if (err) row.append(el('div', 'mod-err', 'Error: ' + err));
        box.append(row);
      }
      const add = el('details', 'mod-add'); add.append(el('summary', '', 'Add a mod'));
      const ta = el('textarea'); ta.placeholder = '// @name My Mod\n// @version 1.0\n// @description What it does\ntt.panel({ title: \'Hello\' });\ndocument.body.textContent = \'Hi!\';';
      const file = el('input'); file.type = 'file'; file.accept = '.js,text/javascript,text/plain';
      const msg = el('p', 'err');
      const go = el('button', 'btn primary', 'Install'); go.type = 'button';
      const install = (code: string) => { const r = mods.install(code); msg.textContent = r.ok ? '' : r.msg; if (r.ok) rerender(); };
      go.addEventListener('click', () => install(ta.value));
      file.addEventListener('change', async () => { const f = file.files?.[0]; if (f) { if (f.size > 200 * 1024) { msg.textContent = 'That file is over 200 KB.'; return; } install(await f.text()); } });
      add.append(el('p', 'set-note', 'Only add mods from people you trust. See MODS.md in the game\'s repository for the mod API.'), ta, file, go, msg);
      box.append(add);
    },
  };
}
